import React from 'react';
import PropTypes from 'prop-types';

const Image = ({ url, alt }) => <img src={url} className="fit mb3" alt={alt} />;

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default Image;
